(function () {
    'use strict';

    angular
        .module('surveys')
        .config(SurveysRoute);

   SurveysRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function SurveysRoute($stateProvider) {
        $stateProvider
            .state('root.surveys', {
                disableCache: true,
                abstract: true,
                url: '/surveys',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                },
            })
            .state('root.surveys.expo', {
                disableCache: true,
                url: '/expo',
                data : { event_type: 'physical' },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/surveys/stats/reportFilter.html',
                        controller: 'SurveysController',
                        controllerAs: 'surveysController'                        
                    }
                }
            })
            .state('root.surveys.virtual', {
                disableCache: true,
                url: '/virtual',
                data : { event_type: 'virtual' },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/surveys/stats/reportFilter.html',
                        controller: 'SurveysController',
                        controllerAs: 'surveysController'                        
                    }
                }
            });
    }
})();